import {BASE_URL, GET, WIDGET_LAYOUT_CONFIG,} from "../constants";
import { statusParsing, jsonParsing } from "../utils";
import { getAccessToken } from "../../authActions/authActions";
  

export const getWidgetLayout = async (requestId) => {
    const token = await getAccessToken();
    const url = `${BASE_URL}${WIDGET_LAYOUT_CONFIG}`;
    return fetch(url, {
        method: GET,
        headers: {
          "Content-Type": "application/json",
          "userauth" : `bearer ${token}`
        },
      })
      .then(statusParsing)
      .then(jsonParsing);
  };